const HeroSchema = {
  title: 'Hero',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'backgroundImage',
        'autoplayMs',
        'slides',
      ],
    },
  ],
  properties: {
    backgroundImage: {
      title: 'Background Image',
      type: 'string',
      widget: 'image',
    },
    autoplayMs: {
      title: 'Autoplay Speed',
      description: 'Sets the slide rotation speen in milliseconds',
      type: 'number',
      default: 6000,
    },
    slides: {
      title: 'Slides',
      widget: 'object_list',
      schema: {
        title: 'slide',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'layout',
              'title',
              'subtitle',
              'image',
              'buttons',
            ],
          },
        ],
        properties: {
          layout: {
            title: 'Layout',
            type: 'string',
            choices: [
              ['center', 'Center'],
              ['split', 'Split'],
            ],
            default: 'center'
          },
          title: {
            title: 'Title',
            type: 'string',
          },
          subtitle: {
            title: 'Content',
            widget: 'textarea',
            type: 'string',
          },
          image: {
            title: 'Image',
            type: 'string',
            widget: 'image',
          },
          buttons: {
            title: 'Buttons',
            widget: 'object_list',
            schema: {
              title: 'Button',
              fieldsets: [
                {
                  id: 'default',
                  title: 'Default',
                  fields: [
                    'variant', 
                    'text',
                    'icon',
                    'externalUrl',
                    'link',
                  ],
                },
              ],
              properties: {
                variant: {
                  title: 'Variant',
                  type: 'string',
                  choices: [
                    ['variant1', 'Variant 1'],
                    ['variant2', 'Variant 2'],
                  ],
                  default: 'variant1'
                },
                text: {
                  title: 'Text',
                  type: 'string',
                },
                icon: {
                  title: 'Icon',
                  type: 'string',
                  description: 'Accepts any Semantic UI icon name',
                },
                externalUrl: {
                  title: 'External URL (Variant 1 only)',
                  description: 'Links to a URL ouside of this site',
                  type: 'string',
                },
                link: {
                  title: 'Link (variant 2 only)',
                  description: 'Links to a page within this site',
                  widget: 'object_browser',
                  mode: 'link',
                  selectableTypes: ['Document'],
                },
              },
              required: [],
            },
          },
        },
        required: [],
      },
    },
  },
  required: [],
};

export default HeroSchema;
